import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import BillingSummaryCard from "./BillingSummaryCard"
import BillingBreakdownTable from "./BillingBreakdownTable"
import { values } from "lodash"
import { Theme, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useGetBillingSummaryQuery } from "../../organisations/api"

const BillingSummaryPanel = ({ orgId }: { orgId: string }) => {
  const classes = useStyles()
  const { t } = useTranslation("org")
  const { data: billingData, error, isLoading } = useGetBillingSummaryQuery(orgId, { refetchOnMountOrArgChange: true })

  if (isLoading) return <div>Loading...</div>
  if (error || !billingData) return <div>Error: {error}</div>
  const { total, subtotal, summary, breakdown, discounts } = billingData

  return (
    <div className={classes.container} data-test="section-container">
      <Typography variant="h5" style={{ marginBottom: 16 }}>
        {t("orgBillingPage.billingSummaryTitle")}
      </Typography>
      <BillingSummaryCard total={total} subtotal={subtotal} summary={values(summary)} discounts={discounts} />
      <div className={classes.breakdownHeader}>
        <Typography variant="h5">{t("orgBillingPage.breakdownTitle")}</Typography>
        <a href="https://www.starbrix.app/en/pricing" target="_blank" rel="noreferrer">
          <Button variant="outlined" size="small">
            {t("orgBillingPage.viewPricing")}
          </Button>
        </a>
      </div>
      <BillingBreakdownTable breakdown={breakdown} />
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& > h6, & > div": {
      marginBottom: theme.spacing(2.5),
    },
  },
  breakdownHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
}))

export default BillingSummaryPanel
